module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/access_main-visual-f1a5190effc39125fb24be2cfbf070f9.jpg";